import React, { Component, useState } from "react"
import "./FormInicial.css"
import { MDBRow, MDBCol, MDBContainer } from "mdbreact"
import { TextField } from "formik-material-ui"
import axios from "axios"
import { Formik, Field, withFormik } from "formik"
import FormInicialSchema from "./FormInicialSchema"
import MenuItem from "@material-ui/core/MenuItem"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import Typography from "@material-ui/core/Typography"
import Swal from "sweetalert2"
import Alert from "@material-ui/lab/Alert"
import FormDocumentacion from "../FormDocumentacion/FormDocumentacion"
import error404 from "../../assets/images/404.png"

import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import FormHelperText from "@material-ui/core/FormHelperText"

import Select from "@material-ui/core/Select"
import * as Yup from "yup"

var first = Math.random().toString(36).substr(2)
var token = first.substr(0, 8).toUpperCase()
let arrProceso = []

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    Carnet: Yup.string()
      .min(8, "El carné es demasiado corto")
      .max(8, "El carné es demasiado lago")
      .required("El carné es requerido")
      .matches(/^[a-zA-Z]{2}[\d]{6}/, {
        message: "El número de carné es inválido",
        excludeEmptyString: true,
      }),
    Proceso: Yup.string().required("El proceso es requerido"),
    Modalidad: Yup.string()
      .notRequired()
      .when("Proceso", {
        is: (val) => {
          return val === "PROCESO DE GRADUACIÓN"
        },
        then: Yup.string().required("La modalidad es requerida"),
        otherwise: Yup.string().notRequired(),
      }),
    MaesOpciones: Yup.string()
      .notRequired()
      .when("Modalidad", {
        is: (val) => {
          return val === "ESPECIALIZACIÓN"
        },
        then: Yup.string().required("La opción especialización es requerida"),
        otherwise: Yup.string().notRequired(),
      }),
    MaesOpciones: Yup.string()
      .notRequired()
      .when("Proceso", {
        is: (val) => {
          return val === "MAESTRÍA"
        },
        then: Yup.string().required("La opción de maestría es requerida"),
        otherwise: Yup.string().notRequired(),
      }),
    TipoTitulacion: Yup.string().required("El tipo de titulación es requerida"),
    IdSede: Yup.string().required("La sede es requerida"),
    Email: Yup.string()
      .email("El email ingresado es inválido")
      .required("El email es requerido"),
    Telefono: Yup.string()
      .min(8, "El teléfono es demasiado corto")
      .max(8, "El teléfono es demasiado lago")
      .optional()
      .matches(/^[\d]{8}/, {
        message: "El teléfono es inválido",
        excludeEmptyString: true,
      }),
  }),
  mapPropsToValues: (props) => ({
    Proceso: "",
    IdSede: "",
    Modalidad: "",
    ModOpciones: "",
    MaesOpciones: "",
    TipoTitulacion: "",
    Carnet: "",
    Email: "",
    Telefono: "",
    Token: token,
  }),
  handleSubmit: (values, { setStatus, setSubmitting }) => {
    const payload = {
      ...values,
      //topic: values.topic.value
    }
    setTimeout(() => {
      axios({
        url: process.env.REACT_APP_DOCUMENTACIONAPI + "searchinfo",
        method: "post",
        data: JSON.stringify(values),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          switch (response.data.Code) {
            case 200:
              setStatus({
                formValues: values,
                dataValues: response.data.Informacion,
                openFormDocumentacion: true,
              })
              break
            default:
              setStatus({
                formValues: values,
                dataValues: response.data.Informacion,
                openFormDocumentacion: false,
                msgError: response.data.Message,
              })

              break
          }
        })
        .catch((err) => {
          switch (err?.response?.data?.Code) {
            case 302:
              setStatus({
                formValues: "",
                dataValues: "",
                openFormDocumentacion: false,
                msgError: err?.response?.data?.Message,
                iconMsgError: "info",
              })
              break
            default:
              setStatus({
                formValues: "",
                dataValues: "",
                openFormDocumentacion: false,
                msgError: err?.response?.data?.Message,
                iconMsgError: "error",
              })
              break
          }
        })

      // alert(JSON.stringify(payload, null, 2));
      setSubmitting(false)
    }, 1000)
  },
})

const closeModalDocumentacion = (event) => {
  Swal.fire({
    title: "CONFIRMAR ACCIÓN",
    text: "Si cierra la venta, no se alojarán sus documentos",
    icon: "info",
    showCancelButton: true,
    cancelButtonText: "CANCELAR",
    confirmButtonText: "CONFIRMAR",
  }).then((result) => {
    if (result.value) {
      window.location.reload(true)
    }
  })
}

class Sltproceso extends React.Component {
  state = {
    arrProcesos: "",
    msgErrorNetwork: "",
    fechasProcesosActivos: "",
  };

  handleChange = (value) => {
    // this is going to call setFieldValue and manually update values.topcis
    this.props.onChange("Proceso", value.target.value)
  };

  handleBlur = () => {
    // this is going to call setFieldTouched and manually update touched.topcis
    this.props.onBlur("Proceso", true)
  };

  async componentDidMount() {
    await axios({
      url: process.env.REACT_APP_CATALOGOAPI + "procesosdocumentacion",
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        this.setState({
          arrProcesos: response.data.Procesos,
        })
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          this.setState({
            msgErrorNetwork: true,
          })
        }
        this.setState({
          arrProcesos: null,
        })
      })

    await axios({
      url: process.env.REACT_APP_DOCUMENTACIONAPI + "tramites",
      // url: "http://localhost:4005/api/v1/tramites",
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        const { fechas } = response.data
        this.setState({ fechasProcesosActivos: fechas })
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          this.setState({ msgErrorNetwork: true })
        }

        this.setState({ arrProcesos: null })
      })
  }

  render() {
    return (
      <FormControl className="w-100">
        <InputLabel
          id="demo-simple-select-helper-label"
          className={
            !!this.props.error && this.props.touched
              ? "Mui-error Mui-error"
              : " "
          }
        >
          Trámite
        </InputLabel>
        <Select
          id="Proceso"
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={this.props.value}
          fullWidth
          className={
            !!this.props.error && this.props.touched
              ? "Mui-error Mui-error"
              : " "
          }
        >
          {this.state.fechasProcesosActivos &&
            this.state.fechasProcesosActivos.map((fecha, key) => {
              return (
                <MenuItem key={key} value={fecha.proceso}>
                  {fecha.proceso}
                </MenuItem>
              )
            })}
        </Select>
        {!!this.props.error && this.props.touched && (
          <FormHelperText className="Mui-error">
            {this.props.error}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}

class Sltsede extends React.Component {
  state = {
    arrSedes: "",
    arrSedesFiltradas: "",
    msgErrorNetwork: "",
  };

  handleChange = (value) => {
    // this is going to call setFieldValue and manually update values.topcis
    this.props.onChange("IdSede", value.target.value)

  };

  handleBlur = () => {
    // this is going to call setFieldTouched and manually update touched.topcis
    this.props.onBlur("IdSede", true)
  };

  componentDidUpdate(prevProps) {
    // Comprueba si procesoSeleccionado ha cambiado
    if (this.props.procesoSeleccionado !== prevProps.procesoSeleccionado) {
      this.filtrarSedes()
    }
  }

  async componentDidMount() {
    this.filtrarSedes([])
    await axios({
      url: process.env.REACT_APP_CATALOGOAPI + "sedes",
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        this.setState({
          arrSedes: response.data.Sedes,
        })
        this.filtrarSedes(response.data.Sedes)
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          this.setState({
            msgErrorNetwork: true,
          })
        }
        this.setState({
          arrSedes: null,
        })
      })
  }

  filtrarSedes = (val) => {
    const procesoSeleccionado = this.props?.procesoSeleccionado
    if (!procesoSeleccionado) {
      this.setState({ arrSedesFiltradas: val.filter((sede) => sede.NombreSede == "SAN SALVADOR") })
      return
    }

    // dependiendo del proceso seleccionado se filtran las sedes que corresponden al arreglo arrSedes
    // si el proceso seleccionado es "PROCESO DE GRADUACIÓN" se mostraran todas las sedes
    // si el proceso  es diferente a "PROCESO DE GRADUACIÓN" se mostraran solo las sedes donde sea igual al 'SAN SALVADOR'
    if (procesoSeleccionado === "PROCESO DE GRADUACIÓN" && procesoSeleccionado) {
      this.setState({ arrSedesFiltradas: this.state.arrSedes })
    } else {
      this.setState({ arrSedesFiltradas: this.state.arrSedes.filter((sede) => sede.NombreSede == "SAN SALVADOR") })
    }

  }
  render() {
    return (
      <FormControl className="w-100">
        <InputLabel
          id="demo-simple-select-helper-label"
          className={
            !!this.props.error && this.props.touched
              ? "Mui-error Mui-error"
              : " "
          }
        >
          Sede
        </InputLabel>
        <Select
          id="IdSede"
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={this.props.value}
          fullWidth
          className={
            !!this.props.error && this.props.touched
              ? "Mui-error Mui-error"
              : " "
          }
        >
          {this.state.arrSedesFiltradas &&
            this.state.arrSedesFiltradas.map((e, key) => {

              return (
                <MenuItem key={key} value={e.IdSede}>
                  {e.NombreSede}
                </MenuItem>
              )



            })}
        </Select>
        {!!this.props.error && this.props.touched && (
          <FormHelperText className="Mui-error">
            {this.props.error}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}

class Slttitulacion extends React.Component {
  state = {
    arrTipoTitulacion: "",
    msgErrorNetwork: "",
  };

  handleChange = (value) => {
    // this is going to call setFieldValue and manually update values.topcis
    this.props.onChange("TipoTitulacion", value.target.value)
  };

  handleBlur = () => {
    // this is going to call setFieldTouched and manually update touched.topcis
    this.props.onBlur("TipoTitulacion", true)
  };

  async componentDidMount() {
    await axios({
      url: process.env.REACT_APP_CATALOGOAPI + "tipotitulaciones",
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        this.setState({
          arrTipoTitulacion: response.data.TipoTitulaciones,
        })
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          this.setState({
            msgErrorNetwork: true,
          })
        }
        this.setState({
          arrTipoTitulacion: null,
        })
      })
  }

  render() {
    return (
      <FormControl className="w-100">
        <InputLabel
          id="demo-simple-select-helper-label"
          className={
            !!this.props.error && this.props.touched
              ? "Mui-error Mui-error"
              : " "
          }
        >
          Titulación
        </InputLabel>
        <Select
          id="TipoTitulacion"
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={this.props.value}
          fullWidth
          className={
            !!this.props.error && this.props.touched
              ? "Mui-error Mui-error"
              : " "
          }
        >
          {this.state.arrTipoTitulacion &&
            this.state.arrTipoTitulacion.map((e, key) => {
              return (
                <MenuItem key={key} value={e.IdTipoTitulacion}>
                  {e.TipoTitulacion}
                </MenuItem>
              )
            })}
        </Select>
        {!!this.props.error && this.props.touched && (
          <FormHelperText className="Mui-error">
            {this.props.error}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}

class Sltmodalidad extends React.Component {
  state = {
    arrModalidad: "",
    msgErrorNetwork: "",
  };

  handleChange = (value) => {
    // this is going to call setFieldValue and manually update values.topcis
    this.props.onChange("Modalidad", value.target.value)
  };

  handleBlur = () => {
    // this is going to call setFieldTouched and manually update touched.topcis
    this.props.onBlur("Modalidad", true)
  };

  async componentDidMount() {
    await axios({
      url: process.env.REACT_APP_CATALOGOAPI + "procesosdocumentacion",
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        let procesos = response.data.Procesos
        procesos.forEach((procs) => {
          if (procs.NombreProceso === "PROCESO DE GRADUACIÓN") {
            this.setState({
              arrModalidad: procs.Modalidades,
            })
          }
        })
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          this.setState({
            msgErrorNetwork: true,
          })
        }
        this.setState({
          arrTipoTitulacion: null,
        })
      })
  }

  render() {
    return (
      <FormControl className="w-100">
        <InputLabel
          id="demo-simple-select-helper-label"
          className={
            !!this.props.error && this.props.touched
              ? "Mui-error Mui-error"
              : " "
          }
        >
          Modalidad
        </InputLabel>
        <Select
          id="Modalidad"
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={this.props.value}
          fullWidth
          className={
            !!this.props.error && this.props.touched
              ? "Mui-error Mui-error"
              : " "
          }
        >
          {this.state.arrModalidad &&
            this.state.arrModalidad.map((e, key) => {
              return (
                <MenuItem key={key} value={e.NombreModalidad}>
                  {e.NombreModalidad}
                </MenuItem>
              )
            })}
        </Select>
        {!!this.props.error && this.props.touched && (
          <FormHelperText className="Mui-error">
            {this.props.error}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}

class Sltmodopciones extends React.Component {
  state = {
    arrModOpciones: "",
    msgErrorNetwork: "",
  };

  handleChange = (value) => {
    // this is going to call setFieldValue and manually update values.topcis
    this.props.onChange("ModOpciones", value.target.value)
  };

  handleBlur = () => {
    // this is going to call setFieldTouched and manually update touched.topcis
    this.props.onBlur("ModOpciones", true)
  };

  async componentDidMount() {
    await axios({
      url: process.env.REACT_APP_CATALOGOAPI + "procesosdocumentacion",
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        let procesos = response.data.Procesos
        procesos.forEach((procs) => {
          if (procs.NombreProceso === "PROCESO DE GRADUACIÓN") {
            let modalidades = procs.Modalidades
            modalidades.forEach((moda) => {
              if (moda.NombreModalidad === "ESPECIALIZACIÓN") {
                this.setState({
                  arrModOpciones: moda.Opciones,
                })
              }
            })
          }
        })
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          this.setState({
            msgErrorNetwork: true,
          })
        }
        this.setState({
          arrTipoTitulacion: null,
        })
      })
  }

  render() {
    return (
      <FormControl className="w-100">
        <InputLabel
          id="demo-simple-select-helper-label"
          className={
            !!this.props.error && this.props.touched
              ? "Mui-error Mui-error"
              : " "
          }
        >
          Opción especialización
        </InputLabel>
        <Select
          id="ModOpciones"
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={this.props.value}
          fullWidth
          className={
            !!this.props.error && this.props.touched
              ? "Mui-error Mui-error"
              : " "
          }
        >
          {this.state.arrModOpciones &&
            this.state.arrModOpciones.map((e, key) => {
              return (
                <MenuItem key={key} value={e.Opcion}>
                  {e.Opcion}
                </MenuItem>
              )
            })}
        </Select>
        {!!this.props.error && this.props.touched && (
          <FormHelperText className="Mui-error">
            {this.props.error}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}

class Sltmaesopciones extends React.Component {
  state = {
    arrMaesOpciones: "",
    msgErrorNetwork: "",
  };

  handleChange = (value) => {
    // this is going to call setFieldValue and manually update values.topcis
    this.props.onChange("MaesOpciones", value.target.value)
  };

  handleBlur = () => {
    // this is going to call setFieldTouched and manually update touched.topcis
    this.props.onBlur("MaesOpciones", true)
  };

  async componentDidMount() {
    await axios({
      url: process.env.REACT_APP_CATALOGOAPI + "procesosdocumentacion",
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        let procesos = response.data.Procesos
        procesos.forEach((procs) => {
          if (procs.NombreProceso === "MAESTRÍA") {
            this.setState({
              arrMaesOpciones: procs.Modalidades,
            })
          }
        })
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          this.setState({
            msgErrorNetwork: true,
          })
        }
        this.setState({
          arrTipoTitulacion: null,
        })
      })
  }

  render() {
    return (
      <FormControl className="w-100">
        <InputLabel
          id="demo-simple-select-helper-label"
          className={
            !!this.props.error && this.props.touched
              ? "Mui-error Mui-error"
              : " "
          }
        >
          Opción maestría
        </InputLabel>
        <Select
          id="MaesOpciones"
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={this.props.value}
          fullWidth
          className={
            !!this.props.error && this.props.touched
              ? "Mui-error Mui-error"
              : " "
          }
        >
          {this.state.arrMaesOpciones &&
            this.state.arrMaesOpciones.map((e, key) => {
              return (
                <MenuItem key={key} value={e.NombreModalidad}>
                  {e.NombreModalidad}
                </MenuItem>
              )
            })}
        </Select>
        {!!this.props.error && this.props.touched && (
          <FormHelperText className="Mui-error">
            {this.props.error}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}

const MyForm = (props) => {
  const {
    values,
    touched,
    dirty,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    handleReset,
    setFieldValue,
    setFieldTouched,
    isSubmitting,
    openFormDocumentacion = props.status && props.status.openFormDocumentacion,
  } = props

  return (
    <MDBContainer>
      <form onSubmit={handleSubmit}>
        <MDBRow>
          <MDBCol size="12" sm="12" md="12" lg="12" xl="12">
            <h4 className="text-important">
              Completa el formulario para realizar el envío de tus documentos en
              línea
            </h4>
          </MDBCol>
        </MDBRow>
        <div className="row">
          <MDBCol className="mb-3 col-12 col-md-6">
            <Sltproceso
              value={values.Proceso}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              error={errors.Proceso}
              touched={touched.Proceso}
            />
          </MDBCol>
          <MDBCol
            className={
              props.values.Proceso === "PROCESO DE GRADUACIÓN"
                ? "mb-3 col-12 col-md-6"
                : "mb-3 col-12 col-md-6 d-none"
            }
          >
            <Sltmodalidad
              value={values.Modalidad}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              error={errors.Modalidad}
              touched={touched.Modalidad}
            />
          </MDBCol>
          <MDBCol
            className={
              props.values.Proceso === "PROCESO DE GRADUACIÓN" &&
                props.values.Modalidad === "ESPECIALIZACIÓN"
                ? "mb-3 col-12 col-md-6"
                : "mb-3 col-12 col-md-6 d-none"
            }
          >
            <Sltmodopciones
              value={values.ModOpciones}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              error={errors.ModOpciones}
              touched={touched.ModOpciones}
            />
          </MDBCol>
          <MDBCol
            className={
              props.values.Proceso === "MAESTRÍA"
                ? "mb-3 col-12 col-md-6"
                : "mb-3 col-12 col-md-6 d-none"
            }
          >
            <Sltmaesopciones
              value={values.MaesOpciones}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              error={errors.MaesOpciones}
              touched={touched.MaesOpciones}
            />
          </MDBCol>
          <MDBCol className="mb-3 col-12 col-md-6">

            <Sltsede
              procesoSeleccionado={values.Proceso}
              value={values.IdSede}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              error={errors.IdSede}
              touched={touched.IdSede}
            />
          </MDBCol>
          <MDBCol className="mb-3 col-12 col-md-6">
            <Slttitulacion
              value={values.TipoTitulacion}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              error={errors.TipoTitulacion}
              touched={touched.TipoTitulacion}
            />
          </MDBCol>
          <MDBCol className="mb-3 col-12 col-md-6">
            <Field
              component={TextField}
              name="Carnet"
              label="Carné"
              autoComplete="off"
              fullWidth
              id="Carnet"
              type="text"
              value={values.Carnet.toUpperCase()}
              onChange={handleChange}
              onBlur={handleBlur}
              inputProps={{
                maxLength: 8,
              }}
            />
          </MDBCol>
          <MDBCol className="mb-3 col-12 col-md-6">
            <Field
              component={TextField}
              name="Telefono"
              label="Teléfono"
              autoComplete="off"
              fullWidth
              inputProps={{
                maxLength: 8,
              }}
            />
          </MDBCol>
          <MDBCol className="mb-3 col-12 col-md-6">
            <Field
              component={TextField}
              name="Email"
              label="Email"
              autoComplete="off"
              fullWidth
              inputProps={{
                maxLength: 100,
              }}
            />
          </MDBCol>
          {props.status ? (
            props.status.msgError ? (
              <MDBCol className="mb-3 col-12">
                <Alert severity={props.status && props.status.iconMsgError}>
                  {props.status.msgError}
                </Alert>
              </MDBCol>
            ) : null
          ) : (
            ""
          )}
        </div>
        <div className="row">
          <MDBCol className="p-4 d-flex justify-content-end">
            <Button
              variant="contained"
              type="submit"
              disabled={isSubmitting}
              className="bt-send-form"
            >
              {isSubmitting ? "Iniciando" : "Iniciar"}
            </Button>
          </MDBCol>
        </div>
      </form>
      <div>
        {/* {JSON.stringify(props, null, 2)} */}
        <Dialog
          fullScreen
          open={props.status ? props.status.openFormDocumentacion : false}
        >
          <AppBar>
            <Toolbar className="center-title-fullmodal">
              <Typography variant="h6">
                {props.status && props.status.formValues.Proceso}
              </Typography>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="close"
                onClick={closeModalDocumentacion}
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent className="center-content-fullmodal m-64">
            <FormDocumentacion
              respDataFormInicial={props.status && props.status.dataValues}
              respDataForm={props.status && props.status.formValues}
              respProceso={props.status && props.status.formValues.Proceso}
              respTitulacion={
                props.status && props.status.formValues.TipoTitulacion
              }
              resToken={props.status && props.status.formValues.Token}
              esTecnico={props.status && props.status.formValues.Modalidad}
            />
          </DialogContent>
        </Dialog>
      </div>
    </MDBContainer>
  )
}

const MyEnhancedForm = formikEnhancer(MyForm)

class FormInicial extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openFormDocumentacion: false,
    }
  }

  openModalDocumentacion = () => {
    this.setState({
      openFormDocumentacion: true,
    })
  };

  closeModalDocumentacion = () => {
    Swal.fire({
      title: "CONFIRMAR ACCIÓN",
      text: "Si cierra la venta, no se alojarán sus documentos",
      icon: "info",
      showCancelButton: true,
      cancelButtonText: "CANCELAR",
      confirmButtonText: "CONFIRMAR",
    }).then((result) => {
      if (result.value) {
        window.location.reload(true)
      }
    })
  };

  render() {
    return (
      <div>
        <MyEnhancedForm />
      </div>
    )
  }
}

export default FormInicial
